import { createSelector } from 'reselect'

// PLOP_APPEND_PATTERN_ANCHOR

// get self accounts
export const selfAccountsSelector = createSelector(
  ({ selfAccounts }) => selfAccounts.selfAccounts.results,
  results => results
)

export const selfAccountsIsLoadingSelector = createSelector(
  ({ selfAccounts }) => selfAccounts.selfAccounts.isLoading,
  isLoading => isLoading
)

export const selfAccountsWasLoadedSelector = createSelector(
  ({ selfAccounts }) => selfAccounts.selfAccounts.wasLoaded,
  wasLoaded => wasLoaded
)

export const selfAccountsErrorSelector = createSelector(
  ({ selfAccounts }) => selfAccounts.selfAccounts.error,
  error => error
)

// get self account
export const selfAccountSelector = createSelector(
  ({ selfAccounts }) => selfAccounts.selfAccount.data,
  data => data
)

export const selfAccountIsLoadingSelector = createSelector(
  ({ selfAccounts }) => selfAccounts.selfAccount.isLoading,
  isLoading => isLoading
)

export const selfAccountErrorSelector = createSelector(
  ({ selfAccounts }) => selfAccounts.selfAccount.error,
  error => error
)

export const selfAccountWasLoadedSelector = createSelector(
  ({ selfAccounts }) => selfAccounts.selfAccount.wasLoaded,
  wasLoaded => wasLoaded
)

// get partner self account
export const partnerSelfAccountSelector = createSelector(
  ({ selfAccounts }) => selfAccounts.partnerSelfAccount.data,
  data => data
)

export const partnerSelfAccountIsLoadingSelector = createSelector(
  ({ selfAccounts }) => selfAccounts.partnerSelfAccount.isLoading,
  isLoading => isLoading
)

export const partnerSelfAccountErrorSelector = createSelector(
  ({ selfAccounts }) => selfAccounts.partnerSelfAccount.error,
  error => error
)

export const partnerSelfAccountWasLoadedSelector = createSelector(
  ({ selfAccounts }) => selfAccounts.partnerSelfAccount.wasLoaded,
  wasLoaded => wasLoaded
)

// create self account
export const createSelfAccountIsLoadingSelector = createSelector(
  ({ selfAccounts }) => selfAccounts.createSelfAccount.isLoading,
  isLoading => isLoading
)

export const createSelfAccountErrorSelector = createSelector(
  ({ selfAccounts }) => selfAccounts.createSelfAccount.error,
  error => error
)

export const wasSelfAccountCreatedSelector = createSelector(
  ({ selfAccounts }) => selfAccounts.createSelfAccount.wasCreated,
  wasCreated => wasCreated
)

// update self account
export const updateSelfAccountSelector = createSelector(
  ({ selfAccounts }) => selfAccounts.updateSelfAccount,
  updateSelfAccount => updateSelfAccount
)

export const updateSelfAccountIsLoadingSelector = createSelector(
  ({ selfAccounts }) => selfAccounts.updateSelfAccount.isLoading,
  isLoading => isLoading
)

export const updateSelfAccountErrorSelector = createSelector(
  ({ selfAccounts }) => selfAccounts.updateSelfAccount.error,
  error => error
)

export const updateSelfAccountWasUpdatedSelector = createSelector(
  ({ selfAccounts }) => selfAccounts.updateSelfAccount.wasUpdated,
  wasUpdated => wasUpdated
)
